import { Icons } from "assets";
import classNames from "classnames";
import { useEffect } from "react";
import Separator from "../common/separater";
import styles from "./style.module.scss";

interface SideCanvasProps {
  data: any;
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
}

const ComplaintSideCanvas = ({ data, isOpen, setIsOpen }: SideCanvasProps) => {
  function handleClick(e: any) {
    const elem: any = document.getElementById("ComplaintSideCanvas");
    if (!elem.contains(e.target)) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    let elem: any = document.getElementById("complaintBackDropContainer");
    if (elem) {
      elem.addEventListener("click", (event: any) => {
        handleClick(event);
      });
    }

    // eslint-disable-next-line
  }, []);

  return (
    <aside
      className={classNames(styles.backDropContainer)}
      style={isOpen ? { visibility: "visible" } : { visibility: "hidden" }}
      id="complaintBackDropContainer"
    >
      <div
        className={classNames(
          styles.mainContainer,
          isOpen ? styles.shown : styles.hidden,
          "py-5"
        )}
        id="ComplaintSideCanvas"
      >
        <div
          className={classNames(
            "flex justify-between items-center px-5 pb-5 gap-4"
          )}
        >
          <div className={classNames("flex items-center gap-3")}>
            <div className={classNames(styles.avtContainer)}>
              <label>
                {data?.user?.name?.[0]}
                {data?.user?.name?.split(" ")?.[1]?.[0]}
              </label>
            </div>
            <div className={classNames("flex flex-col gap-1")}>
              <h4 className={classNames(styles.userTitle)}>
                {data?.user?.name}
              </h4>
              <label className={classNames(styles.userEmail)}>
                {data?.user?.email}
              </label>
            </div>
          </div>
          <Icons.ArrowRightOutline
            className={classNames(styles.backIcon)}
            onClick={() => {
              setIsOpen(false);
            }}
          />
        </div>
        <Separator />
        <div className={classNames("flex flex-col p-5 gap-3")}>
          <h1>{data?.user?.organization?.name}</h1>
          <h1>{data?.subject}</h1>
          <p>{data?.msg}</p>
        </div>
      </div>
    </aside>
  );
};

export default ComplaintSideCanvas;
